import React from 'react';
import './App.css';
import './Services.css';
import Navbar from './Navbar';

const Services = () => (
    <div className="App">
        <header className="hero-section">
            <Navbar />
            <div className="services-section">
                <h2>SERVICES</h2>
                <p>At Boun Health & Performance, we offer a holistic approach to fitness that helps you achieve lasting results.</p>
                <div class="service-container">
                    <div class="service-box">
                        <h3>1-on-1 Personal Training</h3>
                        <p>Receive one-on-one, in-person coaching to master proper form, build strength, and enhance performance.</p>
                    </div>

                    <div class="service-box">
                        <h3>Online Coaching</h3>
                        <p>Get personalized plans and accountability from anywhere. Perfect for busy professionals or those who prefer to train on their own schedule.</p>
                    </div>

                    <div class="service-box">
                        <h3>Beginner-Friendly Training</h3>
                        <p>Start your fitness journey with confidence! Our introductory programs focus on foundational movements, proper technique, and building a comfortable routine.</p>
                    </div>

                    <div class="service-box">
                        <h3>Injury-Conscious Programs</h3>
                        <p>Our specialty in restorative and rehabilitative exercises helps you overcome pain, improve mobility, and build a strong foundation.</p>
                    </div>
                </div>
                <p>We're committed to your success. Book your consultation today!</p>
            </div>



        </header>
        <footer className="footer">
            <p>&copy; {new Date().getFullYear()} Boun Health & Performance</p>
        </footer>
    </div>


);

export default Services;
